import { Component, Input } from "@angular/core";

@Component({
  selector: "med-avatar",
  templateUrl: "./med-avatar.component.html",
  styleUrls: ["./med-avatar.component.scss"],
})
export class MedAvatarComponent {
  @Input() initials = "";
}
